import { ScheduleContainer, ScheduleItem, Separator } from "./styles";

const formatTimeRange = (startTime, endTime) => {
  if (startTime && endTime) {
    return `${startTime.slice(0, 5)}–${endTime.slice(0, 5)}`;
  }
  if (startTime) {
    return startTime.slice(0, 5);
  }
  if (endTime) {
    return endTime.slice(0, 5);
  }
  return "";
};

const Schedule = ({ days = [], error }) => {
  const hasDays = !error && days.length > 0;

  return (
    <ScheduleContainer>
      {hasDays && <h2>{"Today's Schedule"}</h2>}


      {hasDays && (
        <>
          {days.map((day) => (
            <ScheduleItem key={day.id}>
              <div className="schedule-list">
                {day.title && <p className="bold">{day.title}</p>}
                {day.subtitle && <p>{day.subtitle}</p>}
                <Separator />
                {day.agendaItems?.map((item) => {
                  const time = formatTimeRange(item.startTime, item.endTime);
                  const startTimePrefix = item.startTimePrefix || "";
                  return (
                    <p className="schedule-item" key={item.id}>
                      <span className="time">{startTimePrefix} {time}</span>
                      {time ? " - " : ""}
                      <span className={!time ? "time" : ""}>{item.title}</span>
                      {item.description && (
                        <span>{` - ${item.description}`}</span>
                      )}
                    </p>
                  );
                })}
              </div>
            </ScheduleItem>
          ))}
        </>
      )}
    </ScheduleContainer>
  );
};

export default Schedule;

